import { render, staticRenderFns } from "./DesignTeam.vue?vue&type=template&id=27268c1e"
import script from "./DesignTeam.vue?vue&type=script&lang=js"
export * from "./DesignTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports